import React, { useEffect, useReducer, useState } from 'react';
import TextInput from '../../Common/TextInput';
import ActivityLoader from '../../Common/ActivityLoader';
import Notification from '../../Common/Notification';
import CallOut from '../../Common/CallOut';
import { useTheme } from '../../../DataStore/ThemeContext';
import ajaxConfig from '../../../util/remote/ajaxConfig';

const reducer = (state, action)=>{
    if(action.type === "RESET"){
        return {...initialState}
    }
    return { ...state, [action.type]: action.value };
}

const initialState = {
    apiKey: '',
    username: '',
    password: '',
    url: '',
    loading: false,
}


const EditInterface = ({extInterface}) => {

    const [state, dispatch] = useReducer(reducer, initialState);
    const [info, setInfo] = useState('');
    const {closeSettings, setNotify} = useTheme();
    

    useEffect(()=>{
        if(extInterface){
            dispatch({type: 'apiKey', value: extInterface.api_key});
            dispatch({type: 'username', value: extInterface.username});
            dispatch({type: 'password', value: extInterface.password});
            dispatch({type: 'url', value: extInterface.url});
        }
    }, [extInterface])


    const handleSave=async(event)=>{
        event.preventDefault();
        setInfo('');
        dispatch({type: 'loading', value: true})
        const server_response = await ajaxConfig.updateInterface({
            interface_code: extInterface.interface_code, 
            api_key: state.apiKey, 
            username: state.username, 
            password: state.password,
            url: state.url 
        });
        dispatch({type: 'loading', value: false})
        if(server_response.status==="OK"){
            setNotify(<Notification type="success" message={server_response.message} closable={false}/>)
            extInterface.onComplete();
            closeSettings();
        }else{
            setInfo(<Notification type="danger" message={server_response.message} closable={false}/>)
        }
    }


    return (
        <div className="card-body">

        <CallOut 
            title="Configure External Interface"
            description={`Edit credentials for ${extInterface?.interface_name}`}
         />
        {info}
        <form method='post' onSubmit={handleSave}>

                <TextInput
                    type="text"
                    label="Interface URL"
                    placeholder={`Enter URL for ${extInterface?.interface_name}`}
                    leftIcon="fa fa-link"
                    onChange={e => dispatch({type: 'url', value: e.target.value})}
                    value={state.url}
                    wrap
                />
                <TextInput
                    type="text"
                    label="Username"
                    placeholder={`Enter username for ${extInterface?.interface_name}`}
                    leftIcon="fa fa-user"
                    onChange={e => dispatch({type: 'username', value: e.target.value})}
                    value={state.username}
                    wrap
                    />

                <TextInput
                    type="password"
                    label="Password"
                    placeholder={`Enter password for ${extInterface?.interface_name}`}
                    leftIcon="fa fa-unlock"
                    onChange={e => dispatch({type: 'password', value: e.target.value})}
                    value={state.password}
                    wrap
                    />

                <TextInput
                    type="text"
                    label="API Key"
                    placeholder={`Enter API Key for ${extInterface?.interface_name}`}
                    leftIcon="fa fa-key"
                    onChange={e => dispatch({type: 'apiKey', value: e.target.value})}
                    value={state.apiKey}
                    wrap
                    />
        

                  <div className="text-right">
                    {!state.loading && <button type="submit" className="btn btn-lg btn-success">Save Configurations</button>}
                    {state.loading && <ActivityLoader />}
                </div>

        </form>
        </div>
    );
};

export default EditInterface;